const config = [
  {
    heading: "General",
    types: [
      {
        subHeading: "Bookings",
        access: [],
      },
      {
        subHeading: "Customer List",
        access: [],
      },
      {
        subHeading: "Booking History",
        access: [],
      },
      {
        subHeading: "Customer Policies",
        access: [],
      },
      {
        subHeading: "Create Report",
        access: [],
      },
      {
        subHeading: "View Report",
        access: [],
      },
      {
        subHeading: "Stats",
        access: [],
      },
      {
        subHeading: "Finance Customer",
        access: [],
      },
      {
        subHeading: "Finance Driver",
        access: [],
      },
      {
        subHeading: "Finance Vendor",
        access: [],
      },
      {
        subHeading: "Generate Invoice and Receipts",
        access: [],
      },
      {
        subHeading: "Vehicles",
        access: [],
      },
      {
        subHeading: "Drivers",
        access: [],
      },
      {
        subHeading: "Vendors",
        access: [],
      },
      {
        subHeading: "Dispatch",
        access: [],
      },
    ],
  },
  {
    heading: "Verification Center",
    types: [
      {
        subHeading: "Driver Approvals",
        access: [],
      },
      {
        subHeading: "Vehicle Approvals",
        access: [],
      },
      {
        subHeading: "Vendor Approvals",
        access: [],
      },
      {
        subHeading: "Awaiting Clarification",
        access: [],
      },
      {
        subHeading: "Vendor Onboarding Config",
        access: [],
      },
    ],
  },
  {
    heading: "Support Center",
    types: [
      {
        subHeading: "Complaints",
        access: [],
      },
      {
        subHeading: "FAQs",
        access: [],
      },
      {
        subHeading: "Knowledge Base",
        access: [],
      },
      {
        subHeading: "Training Videos",
        access: [],
      },
    ],
  },
  {
    heading: "Access Control",
    types: [
      {
        subHeading: "Roles",
        access: [],
      },
      {
        subHeading: "Employees",
        access: [],
      },
      {
        subHeading: "Audit Logs",
        access: [],
      },
    ],
  },
  {
    heading: "Operations Setup",
    types: [
      {
        subHeading: "Vehicle Segments",
        access: [],
      },
      {
        subHeading: "Custom Booking",
        access: [],
      },
      {
        subHeading: "Tour Package Management",
        access: [],
      },
      {
        subHeading: "State Tax List",
        access: [],
      },
      {
        subHeading: "Customer",
        access: [],
      },
      {
        subHeading: "Terms and Conditions",
        access: [],
      },
    ],
  },
  {
    heading: "Communication",
    types: [
      {
        subHeading: "Communication",
        access: [],
      },
    ],
  },
  {
    heading: "System Logs",
    types: [
      {
        subHeading: "System Logs",
        access: [],
      },
    ],
  },
];

export { config };
